import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('[ErrorBoundary]', error, info);
  }

  reset = () => this.setState({ hasError: false, error: null, info: null });

  render() {
    if (this.state.hasError) {
      const { error, info } = this.state;
      return (
        <div style={{
          maxWidth: 760, margin: '40px auto', padding: '24px 20px',
          background: 'var(--loss-bg)',
          border: '1px solid #6B3A36',
          borderRadius: 16,
          color: 'var(--loss)',
        }}>
          <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 10 }}> 画面でエラーが発生しました</div>
          <div style={{ fontSize: 'var(--t-note)', color: 'var(--ink)', marginBottom: 14 }}>
            ページの表示に失敗しました。リロードするか、別のページから開き直してください。
          </div>
          <details style={{ fontSize: 'var(--t-note)', color: 'var(--ink-soft)', marginBottom: 14, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            <summary style={{ cursor: 'pointer', color: 'var(--hold)', marginBottom: 8 }}>エラー詳細を表示</summary>
            <div style={{ fontWeight: 700, color: 'var(--loss)' }}>{error && (error.message || String(error))}</div>
            {error && error.stack && (
              <pre style={{ fontSize: 'var(--t-note)', marginTop: 8, overflowX: 'auto' }}>{error.stack}</pre>
            )}
            {info && info.componentStack && (
              <pre style={{ fontSize: 'var(--t-note)', marginTop: 8, overflowX: 'auto', color: 'var(--ink-soft)' }}>{info.componentStack}</pre>
            )}
          </details>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={this.reset} style={{
              padding: '10px 16px', background: 'var(--mark-soft)', color: 'var(--mark)',
              border: '1px solid #33406E', borderRadius: 10,
              fontSize: 'var(--t-note)', fontWeight: 700, cursor: 'pointer',
            }}>もう一度試す</button>
            <button onClick={() => window.location.reload()} style={{
              padding: '10px 16px', background: 'var(--paper-sunk)', color: 'var(--ink-soft)',
              border: '1px solid var(--rule-strong)', borderRadius: 10,
              fontSize: 'var(--t-note)', fontWeight: 700, cursor: 'pointer',
            }}>ページをリロード</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
